
import userProfileBroken from '@/assets/images/user-profile-broken.png'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

/**
 *
 *
 *
 */

export const processUserPhone = userProfile => {
  const ddd = !!userProfile.ddd === true ? String(userProfile.ddd).trim() : ''
  const phone = !!userProfile.tel === true ? String(userProfile.tel).trim() : ''

  return ddd.length === 2 && (phone.length === 8 || phone.length === 9) ? ('(' + ddd + ') ' + (phone.length === 8 ? phone.replace(/(\d{4})(\d{4})/, '$1-$2') : phone.replace(/(\d{5})(\d{4})/, '$1-$2'))) : ''
}

export const hhmmToFloat = hhmm => {
  if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(hhmm)) return 0
  const [hours, minutes] = hhmm.split(':').map(Number)
  return +(hours + minutes / 60).toFixed(2)
}

export const isValidImage = img => img  && typeof img === 'string' && String(img ?? "").indexOf('https://') !== -1

export const processUserCpf = user => {
  let cpf = ''
  try {
    cpf = !!user.cpf === true ? String(user.cpf).replace(/[^0-9]/g, '') : ''
  } catch (userError) {
    cpf = ''
    // [24/01/25] console.log('ERRO NO USUÁRIO:', user, userError) // userDetails.uid
  }
  return cpf
}

export const processUserCnpj = user => {
  let cnpj = ''
  try {
    cnpj = !!user.cnpj === true ? String(user.cnpj).replace(/[^0-9]/g, '') : ''
  } catch (userError) {
    cnpj = ''
    // [24/01/25] console.log('ERRO NO USUÁRIO:', user, userError) // userDetails.uid
  }
  return cnpj
}

export const processUserProfile = user => {
  const ddd = !!user.ddd === true ? String(user.ddd).trim() : ''
  const phone = !!user.tel === true ? String(user.tel).trim() : ''
  const telefone = ddd.length === 2 && (phone.length === 8 || phone.length === 9) ? ('(' + ddd + ') ' + (phone.length === 8 ? phone.replace(/(\d{4})(\d{4})/, '$1-$2') : phone.replace(/(\d{5})(\d{4})/, '$1-$2'))) : ''

  let cpf = processUserCpf(user)
  cpf = cpf.length === 11 ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : '' // SENHOR JESUS

  let cnpj = processUserCnpj(user)
  cnpj = cnpj.length === 14 ? cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : '' // SENHOR JESUS

  return {
    email: !!user.email === true ? String(user.email).trim() : '',
    userName: !!user.nome === true ? String(user.nome).trim() : '',
    userNameAbrev: !!user.nome === true ? nomeAbrev(user.nome) : '',
    img: isValidImage(user.img) ? String(user.img) : userProfileBroken,
    crm: !!user.crm === true ? String(user.crm).trim() : '',
    cpf,
    cnpj,
    ddd,
    telefone,
    conta: !!user.conta === true ? String(user.conta).trim() : '',
    grupos: !!user.grupos === true && typeof user.grupos === 'object' && !Array.isArray(user.grupos) ? user.grupos : null,
  }
}

export const processGroupUserProfile = (groupID, userID, /* currentID, */ user, group) => {
  if (!!user === false) return false

  const userName = String(user?.nome ?? "").trim() || ""
  const userPhone = processUserPhone(user)

  let userCpf = processUserCpf(user)
  userCpf = userCpf.length === 11 ? userCpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : ""

  let userCnpj = processUserCnpj(user)
  userCnpj = userCnpj.length === 14 ? userCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : ""

  // VALOR HORA NO GRUPO
  const hourlyRate = (((user ?? {})?.grupos ?? {})?.[groupID] ?? {})?.hourlyrate ? parseFloat(user.grupos[groupID].hourlyrate) : 0
  const groupHourlyRate = hourlyRate === 0 ? '' : hourlyRate.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })

  const groupUser = ((group ?? {})?.users ?? {})?.[userID] ?? {}

  const isAdmin = groupUser?.admin || false
  const isMaster = groupUser?.master || false

  // OUTPUT
  return {
    // Precisou manter em PROD (23 Feb 2026)
    // Remover "backup" algumas semanas após atualizar PORTAL TELEMEDICINA e GESTOR em PRODUÇÃO com a versão sem "backup"
    backup: user,

    // Fazer o mesmo com esses (Confirmar quais estão 100% fora dos gestores)
    userFistName: userName ? primeiroNome(userName) : '',
    userFirstLastName: userName ? firstLastName(userName) : '',
    userNameAbrev: userName ? nomeAbrev(userName) : '',

    // ------------------------------------------------------------------------------------------------------------
    // Note on 23 Feb 2026 at 10:22 PM - Fernando:
    // Conferir se os atributos de "...user" são usados nos GESTORES (master e master-portaltelemedicina)
    // a fim de reduzir o tamanho da resposta
    ...user,
    // ------------------------------------------------------------------------------------------------------------

    // Verificar se está em uso em algum front-end
    // isMe: userID === currentID,

    userID,
    userImage: isValidImage(user.img || "") ? String(user.img).trim() : userProfileBroken,
    userImageIsValid: isValidImage(user.img || ""),
    userName,
    userEmail: user?.email || "",
    userPhone,
    userCpf,
    userCnpj,
    userCrm: user?.crm || "",
    groupHourlyRate,

    isAdmin,
    isMaster,

    /*
    // [staging-portaltelemedicina / master-portaltelemedicina]
    isMunicipality: groupUser?.municipality || false,
    userMunicipalities: groupUser?.municipalities || false,
    // [staging-portaltelemedicina / master-portaltelemedicina]
    */
  }
}

export const nomeAbrev = $nometodo => {
  const $nome = $nometodo.trim().replace(/ de | do | dos | da | das | e /i, ' ').split(' ')

  // console.log('nomeAbrev[nome]:', $nome)

  if ($nome.length < 2) {
    return $nometodo.length > 16 ? `${$nometodo.substr(0, 16)}...` : $nometodo.trim()
  } else {
    let $nomesMeio = ' '

    for (let $x = 1; $x < $nome.length; $x++) {
      $nomesMeio += $nome[$x].length <= 4 || ($nome[0].length <= 4 && $x === 1) ? ($nome[$x] + ' ') : ($nome[$x].charAt(0).toUpperCase() + '. ')
    }

    // console.log('nomeAbrev[nomesMeio]:', $nomesMeio)

    const saida = $nome[0].length <= 4 ? ($nome[0] + $nomesMeio) : ($nome.shift() + $nomesMeio)

    return saida.trim()
  }
}

export const primeiroNome = nomeCompleto => {
  const $nome = nomeCompleto.split(' ')[0]
  return $nome
}

export const firstLastName = nomeCompleto => {
  const nameWords = nomeCompleto.split(' ')

  let nome = nomeCompleto

  if (nameWords.length === 1) {
    nome = nameWords[0]
  } else if (nameWords.length > 1) {
    nome = nameWords[0] + ' ' + nameWords[nameWords.length - 1]
  }

  return nome
}

/**
 *
 *
 *
 */

export const timestrToSec = timestr => {
  var parts = timestr.split(':')
  return (parts[0] * 3600) + (parts[1] * 60) + (+parts[2])
}

const pad = num => num < 10 ? ('0' + num) : ('' + num)

export const formatSecondsToTime = (seconds, withSeconds = true) => {
  if (withSeconds === true) {
    return [pad(Math.floor(seconds / 3600)), pad(Math.floor(seconds / 60) % 60), pad(seconds % 60)].join(':')
  } else {
    return [pad(Math.floor(seconds / 3600)), pad(Math.floor(seconds / 60) % 60)].join(':')
  }
}

/**
 *
 *
 *
 */

//
// formatMoney(1000.91) = R$ 1.000,91
//

export const formatMoney = valueDecimal => {
  const value = typeof valueDecimal === 'string' ? parseFloat(valueDecimal) : valueDecimal

  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })
}

//
// getFormattedCurrency('R$ 1.000,91') = 1000.91
//

/* export const getFormattedCurrency = value => {
  const curRe = /\D*(\d+|\d.*?\d)(?:\D+(\d{2}))?\D*$/
  const parts = curRe.exec(value)

  return parseFloat(parts[1].replace(/\D/, '') + '.' + (parts[2] ? parts[2] : '00'))
} */

/**
 *
 *
 *
 */

// [20/01/25] store.js
export const durationToFactor = (duration = '00:00') => {
  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (isInteger) {
    return duration
  } else if (isFloat) {
    return duration
  } else if (typeof duration === 'string' && /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(duration)) {
    const explodedDuration = duration.split(':')

    const hours = parseInt(explodedDuration[0])
    const minutes = parseInt(explodedDuration[1])

    // parseFloat(explodedDuration[1]) === 0

    if (minutes === 0) {
      // EXEMPLOS: 00:00 ou 01:00
      return hours
    } else {
      // EXEMPLOS: 00:30 ou 01:30
      // return parseFloat(factor).toFixed(2)
      return (hours + (minutes / 60)).toFixed(3)
    }
  } else if (typeof duration === 'string' && /^([0-1]?[0-9]|2[0-3])$/.test(duration)) {
    // console.log('::: DURATION TO FACTOR:', duration)

    return parseInt(duration)
  } else {
    return 0
  }
}

// [20/01/25] store.js, mixins/scale.mixin.js e TurnsModal.vue
export const timeToFloat = (duration = '00:00') => {
  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (isInteger) {
    return duration
  } else if (isFloat) {
    return duration
  } else if (typeof duration === 'string') {
    const explodedDuration = duration.split(':')
    if (parseFloat(explodedDuration[1]) === 0) {
      return parseInt(explodedDuration[0])
    } else {
      return parseFloat(explodedDuration[0] + '.' + explodedDuration[1]).toFixed(2)
    }
  } else {
    return 0
  }
}

//
// Convert INTEGER to hh:mm:ss if necessary
//

export const formatDbTime = (time = '', includeSeconds = false) => {
  const timeString = String(time).trim()

  // Tratamento especial para 24 horas
  if (timeString === '24' || timeString === '24:00') {
    return includeSeconds ? '24:00:00' : '24:00'
  }

  if (timeString.length === 5) return includeSeconds ? `${timeString}:00` : timeString

  if (timeString.length === 1 || timeString.length === 2) {
    const timeWithZero = timeString.padStart(2, '0')
    return includeSeconds ? `${timeWithZero}:00:00` : `${timeWithZero}:00`
  }

  return ''
}

export const formatDuration = (duration, short = false) => {
  if (duration !== null) {
    const explodedDuration = duration.split(':')

    const hour = parseInt(explodedDuration[0])
    const minute = parseFloat(explodedDuration[1])

    let selectedDurationFmt = ''

    // Tratamento especial para 24 horas
    if (hour === 24 && minute === 0) {
      return '24 horas'
    }

    if (hour > 0 && minute === 0) {
      selectedDurationFmt = hour + (hour === 1 ? ' hora' : ' horas')
    } else if (hour === 0 && minute > 0) {
      if (short) {
        selectedDurationFmt = minute + (minute === 1 ? ' min' : ' min')
      } else {
        selectedDurationFmt = minute + (minute === 1 ? ' minuto' : ' minutos')
      }
    } else if (hour === 0 && minute === 0) {
      selectedDurationFmt = hour + ' horas'
    } else {
      if (short) {
        selectedDurationFmt = `${hour}h ${minute}m`
      } else {
        selectedDurationFmt = hour + (hour === 1 ? ' hora e ' : ' horas e ') + minute + (minute === 1 ? ' minuto' : ' minutos')
      }
    }

    return selectedDurationFmt
  } else {
    return ''
  }
}

export const formatDurationForTable = duration => {
  if (!!duration === false) return ''

  const explodedDuration = duration.split(':')

  const hour = parseInt(explodedDuration[0])
  const minute = parseFloat(explodedDuration[1])

  let selectedDurationFmt = ''

  if (hour > 0 && minute === 0) {
    selectedDurationFmt = hour + 'h'
  } else if (hour === 0 && minute > 0) {
      selectedDurationFmt = minute + 'm'
  } else if (hour === 0 && minute === 0) {
    selectedDurationFmt = hour + ' h'
  } else {
    // selectedDurationFmt = `${hour}h ${minute}m`
    selectedDurationFmt = `${hour}:${minute}`
  }

  return selectedDurationFmt
}

export const formatFloatToScaleDuration = duration => formatDuration(formatDbTime(duration || 0), true)

export const durationToMinutes = durationString => {
  const [hours, minutes] = durationString.split(':').map(Number)
  return hours * 60 + minutes // TOTAL MINUTES
}

export const durationIsTwoHoursOrMore = durationString => durationToMinutes(durationString) >= 120

//
// Format the dates as DD/MM/YYYY
//

export const formatDate = date => {
  var day = date.getDate()
  var month = date.getMonth() + 1 // Months are 0-based, so add 1
  var year = date.getFullYear()

  // Ensure leading zeros for day and month if needed
  if (day < 10) day = '0' + day
  if (month < 10) month = '0' + month

  return day + '/' + month + '/' + year
}

export const isValidDate = dateString => {
  // Check if the input string matches the DD/MM/YYYY format (date format) using a regular expression
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return false
  // Parse the date components
  const [day, month, year] = dateString.split('/').map(Number)
  // Create a new Date object with the parsed components
  const date = new Date(year, month - 1, day) // Month is 0-based
  // Check if the parsed date components match the original date
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

export const parseDate = dateString => {
  // Parse the date components
  const [day, month, year] = dateString.split('/').map(x => parseInt(x))
  // Create a new Date object with the parsed components
  return new Date(year, month - 1, day) // Month is 0-based
}

/**
 * Soma um horário com uma duração.
 * @param {string} startTime - Horário inicial (HH:MM).
 * @param {string} duration - Duração a ser somada (HH:MM, "2h", "30min" ou número).
 * @returns {string} Horário de término formatado (HH:MM ou HH:MM +1).
 */
export const calculateEndTime = (startTime, duration) => {
  const timeToMinutes = (time) => {
    if (!time || typeof time !== 'string') return 0;

    const cleaned = time.trim().toLowerCase();

    // Verifica se é formato "2h", "30min", etc
    if (cleaned.includes('h') || cleaned.includes('min')) {
      let totalMinutes = 0;

      // Extrai horas
      const hoursMatch = cleaned.match(/(\d+)h/);
      if (hoursMatch) {
        totalMinutes += parseInt(hoursMatch[1], 10) * 60;
      }

      // Extrai minutos
      const minutesMatch = cleaned.match(/(\d+)\s*min/);
      if (minutesMatch) {
        totalMinutes += parseInt(minutesMatch[1], 10);
      }

      return totalMinutes;
    }

    const parts = time.split(':');
    if (parts.length === 1) {
      // Se só tem um valor (ex: "30"), trata como minutos
      return parseInt(parts[0], 10) || 0;
    }

    const [hours, minutes] = parts.map(Number);
    return (hours || 0) * 60 + (minutes || 0);
  };

  const startMinutes = timeToMinutes(startTime);
  const durationMinutes = timeToMinutes(duration);

  let totalMinutes = startMinutes + durationMinutes;

  // Verifica se passou para o próximo dia
  //const nextDay = totalMinutes >= 1440;

  // Garante que o resultado fique dentro de 0 a 1439 (24 horas - 1 minuto)
  totalMinutes %= 1440;

  const endHour = Math.floor(totalMinutes / 60) % 24;
  const endMinute = totalMinutes % 60;

  const formatTime = (hour, minute) => {
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  };

  const formattedTime = formatTime(endHour, endMinute);

  // indicador de dia seguinte
  return formattedTime;
}


/**
 * Calcula o saldo do banco de horas de um plantão.
 * * @param {Object} duty - O objeto do plantão
 * @param {boolean} isNewTZ - Flag de timezone
 * @param {string} dateFallback - Data de início (YYYY-MM-DD) caso não tenha check-in.
 * @param {string} timeFallback - Hora de início (HH:mm) caso não tenha check-in
 * @param {string} durationText - Texto visual da duração para desambiguação
 * @returns {number} Saldo em minutos (positivo ou negativo)
 */
export function getShiftBalance(duty, isNewTZ, dateFallback, timeFallback, durationText = '') {
  if (!duty || !duty.end_location || !duty.end_location.timestamp) {
    return 0
  }


  const actualEnd = moment(duty.end_location.timestamp)
  let actualStart

  if (duty.start_location && duty.start_location.timestamp) {
    actualStart = moment(duty.start_location.timestamp)
  }
  else {
    const startDateStr = isNewTZ
      ? moment.utc(dateFallback).format('YYYY-MM-DD')
      : moment(dateFallback).format('YYYY-MM-DD')

    actualStart = moment(`${startDateStr} ${timeFallback}`, 'YYYY-MM-DD HH:mm')
  }

  const workedMinutes = actualEnd.diff(actualStart, 'minutes')


  let scheduledMinutes = 0
  const periodoRaw = duty.periodo
  const textNormalized = (durationText || '').toLowerCase()

  if (typeof periodoRaw === 'string' && periodoRaw.includes(':')) {
    const [hours, minutes] = periodoRaw.split(':').map(Number)
    scheduledMinutes = (hours * 60) + minutes
  }
  else {
    let val = parseFloat(periodoRaw || 0)


    if (textNormalized.includes('minuto') && !textNormalized.includes('hora')) {
      scheduledMinutes = val
    }
    else if (textNormalized.includes('hora') || val <= 48) {
      scheduledMinutes = val * 60
    }
    else {
      scheduledMinutes = val
    }
  }

  return workedMinutes - scheduledMinutes
}
